import {Snackbar} from "@material-ui/core";
import {Alert} from "@material-ui/lab";


export default function Notification(props) {

    const {open, type, message, handleClose, position, hideDuration} = props;


    const handleOnClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        handleClose();
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={hideDuration}
            anchorOrigin={position || {vertical: 'top', horizontal: 'right'}}
            onClose={handleClose}>
            <Alert
                severity={type || 'success'}
                onClose={handleOnClose}>
                {message}
            </Alert>
        </Snackbar>
    )
}
